<template>
  <v-container>
    <SearchForm @update-search-results="onUpdateSearchResults($event)" :search-results="searchResults" @update-sort="onSortChange" v-on="$listeners"/>
    <search-results :search-results="searchResults" :matches="matches" v-on="$listeners" />
  </v-container>
</template>

<script>
import SearchForm from "@/components/search/SearchForm";
import SearchResults from "@/components/search/SearchResults";



export default {
  name: "Search",
  components: {SearchResults, SearchForm},
  data: () => ({
    searchResults: null,
    matches: [],
    sortOrder: 'date'
  }),
  methods: {
    onUpdateSearchResults(searchResults) {
      console.log('Updating search results from event')
      this.searchResults = searchResults;
      if (searchResults !== null) {
        this.matches = searchResults.matches;
        this.matches.sort((a, b) => b.post.created_at - a.post.created_at);
      }
    },
    onSortChange(sortOrder) {
      this.sortOrder = sortOrder;
      console.log('sort update')
      switch (this.sortOrder) {
        case 'percent':
          this.matches.sort((a, b) => b.hamming_match_percent - a.hamming_match_percent);
          break;
        case 'date':
          this.matches.sort((a, b) => b.post.created_at - a.post.created_at);
          break;
        default:
          break;
      }
    }
  },

}
</script>

<style scoped>

</style>